export function clearPhoneNumber(phoneNumber: string): string {
  return phoneNumber.replace(/(\(|\s|-|\))/g, '');
}

/* Длина телефона без символов ()|-|пробелов */
const LENGTH_PHONE_WITHOUT_EXCESS = 11;

export function isValidPhoneNumber(phoneNumber?: string | null): boolean {
  if (!phoneNumber) {
    return false;
  }

  return clearPhoneNumber(phoneNumber).length === LENGTH_PHONE_WITHOUT_EXCESS;
}
